// extracted by mini-css-extract-plugin
export default {"header":"performanceTradesGrid_header__3K1Dn"};